import { InitiativeCategory } from "../../../../../../../common/enums/policy-initiative/initiative-category.enum";
import { showGovernanceForm, showNationalGeneralForm, showNationalGovernanceForm, showNationalRegulationsForm, showNationalStrategyForm, showPolicyFrameWorkForm } from "../fields/step-1-functions";
import { PolicyInitiativeCreateEditComponent } from '../policy-initiative-create-edit.component'

export async function getStep1ConditionForm(
  category: InitiativeCategory,
  context: PolicyInitiativeCreateEditComponent
): Promise<void> {
  switch (category) {
    // Intergovernmental Categories (2) options
    case InitiativeCategory.IntergovernmentalPolicyFrameworks:
      await showPolicyFrameWorkForm(context)
      break
    case InitiativeCategory.IntergovernmentalGovernance:
      await showGovernanceForm(context)
      break
    // National Categories (4) options
    case InitiativeCategory.NationalStrategy:
      await showNationalStrategyForm(context)
      break
    case InitiativeCategory.NationalGovernance:
      await showNationalGovernanceForm(context)
      break
    case InitiativeCategory.NationalRegulations:
      await showNationalRegulationsForm(context)
      break
    case InitiativeCategory.NationalProgrammes:
      await showNationalGeneralForm(context)
      break
  }
}